// extracted by mini-css-extract-plugin
export default {"buttonLink":"LinkButton_buttonLink__b7zf7","iconWrapper":"LinkButton_iconWrapper__E0HzO","label":"LinkButton_label__tNCbh"};